//import { useGetAppTranslationsQuery } from "store/translations/query";
//import { useLanguage } from "./useLanguage";
// import { useLocation, useNavigate } from "react-router";
// import { changeUrlLanguage } from "../helpers";
// import { useCallback, useMemo } from "react";
// import { bool } from "yup";
import { useMemo } from "react";
import { useGetTranslationsQuery } from "store/api";
import { useSalesNetwork } from "./useSalesNetworks";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { setLanguage } from "store/commonSlice";

const useTranslation = () => {
  const { isLoading: isNetworkLoading, network } = useSalesNetwork();
  const { data: translationData } = useGetTranslationsQuery(
    { networkCode: network?.code || "" },
    { skip: !network }
  );

  const language = useAppSelector((state) => state.common.lang);
  const dispatch = useAppDispatch();

  return useMemo(() => {
    return {
      t: (
        code: string,
        args: (number | string | undefined)[] | null = [],
        type: "language" | "message" | "text" = "text",
        emptyIfNoResult: boolean = false
      ) => {
        if (!language || !translationData) {
          return emptyIfNoResult ? "" : code;
        }

        let result = translationData[language]?.[type]?.[code];

        if (args && result) {
          for (let i = 0; i < args.length; i++) {
            result = result.replace(`\${args[${i}]}`, args[i]);
          }
        }

        if (result) {
          return result;
        }

        return emptyIfNoResult ? "" : code;
      },
      isLoading: isNetworkLoading,
      setLanguage: (lang: string) => {
        localStorage.setItem("language", lang);
        dispatch(setLanguage(lang));
      },
      language,
      translations: translationData,
    };
  }, [dispatch, isNetworkLoading, language, translationData]);
};
export default useTranslation;
